import {
	Divider,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@mui/material'
import React from 'react'
import Modal from 'ui/modal/Modal'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface IFatnessTooltipModalProps {
	open: boolean
	onClose: () => void
}

const fatnessData = [
	{ period: 'Начало лактации', days: '0–30 дней', norm: '2,75 – 3,75' },
	{ period: 'Пик лактации', days: '31–100 дней', norm: '2,5 – 3,75' },
	{ period: 'Середина лактации', days: '101–200 дней', norm: '2,5 – 3,25' },
	{ period: 'Завершение лактации', days: '201–305 дней', norm: '2,5 – 3,75' },
	{ period: 'Сухостой 1', days: '306–343 дней', norm: '3,25 – 3,5' },
	{ period: 'Сухостой 2', days: '344–365 дней', norm: '3,25 – 3,5' },
]

const FatnessTooltipModal: React.FC<IFatnessTooltipModalProps> = ({
	open,
	onClose,
}) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			title='Норма упитанности'
			sx={{ width: '656px', maxHeight: '100%' }}
		>
			<Table sx={{ borderCollapse: 'collapse', borderSpacing: 0 }}>
				<TableHead>
					<TableRow sx={{ borderBottom: 'none' }}>
						<TableCell
							sx={{ borderBottom: 'none', pl: 0 }}
							align={'left'}
							width={'40%'}
						>
							<TypographySecondary>Период лактации</TypographySecondary>
						</TableCell>
						<TableCell
							sx={{ borderBottom: 'none', pl: 0 }}
							width={'30%'}
							align={'left'}
						>
							<TypographySecondary>День лактации</TypographySecondary>
						</TableCell>
						<TableCell
							sx={{ borderBottom: 'none', pl: 0 }}
							align={'left'}
							width={'25%'}
						>
							<TypographySecondary>Норма упитанности</TypographySecondary>
						</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
					<TableRow>
						<TableCell colSpan={3} sx={{ padding: 0, borderBottom: 'none' }}>
							<Divider sx={{ my: 0, width: '100%' }} />
						</TableCell>
					</TableRow>

					{fatnessData.map((row, index) => (
						<TableRow key={index} sx={{ borderBottom: 'none' }}>
							<TableCell sx={{ borderBottom: 'none', pl: 0 }}>
								<TypographyPrimary>{row.period}</TypographyPrimary>
							</TableCell>
							<TableCell sx={{ borderBottom: 'none', pl: 0 }}>
								<Stack direction='row' spacing={0.5} alignItems='flex-end'>
									<TypographyPrimary>
										{row.days.replace(' дней', '')}
									</TypographyPrimary>
									<TypographySecondary>дней</TypographySecondary>
								</Stack>
							</TableCell>
							<TableCell sx={{ borderBottom: 'none', pl: 0 }}>
								<TypographyPrimary>{row.norm}</TypographyPrimary>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Modal>
	)
}

export default FatnessTooltipModal
